export const OUT_OF_STOCK = 'stockout'
